module.exports = __webpack_public_path__ + "media/images/logo_ball-11e4c07c.png";